import { defineMessages } from "react-intl";

const messages = defineMessages({
  selectFile: {
    id: "csvUpload.selectFile",
  },
});

export default messages;
